import React from 'react'
import cn from 'classnames'
import st from './index.scss'
import useHomePageBreadCrumbs from '@/hooks/useHomePageBreadCrumbs'

/**
 *
 * @param { children } 通过children传入组件，即可以面包屑的形式展现，传入的组件是Link就可以跳转 比如<Breadcrumb><Link to='/'>当前页面</Link></Breadcrumb>
 * @returns
 */
export default function Breadcrumb({ className, children, showHome = true, ...props }) {
    // const navigate = useNavigate()
    const child = !children.length ? [children] : children

    const { jumpClick } = useHomePageBreadCrumbs()

    return (
        <div className={cn(st['box'], className)} {...props}>
            {showHome ? <span onClick={jumpClick}>首页</span> : ''}
            {showHome ? <div key="home_>" className={st['separator']}>{'>'}</div> : ''}
            {child?.map((item, index) => {
                return item ? [
                    // inner 最后一个高亮展示
                    <div key={index} className={cn({[st['inner']]: index == child.length - 1})}>{item}</div>,
                    index < child.length - 1 && <div key={`${index}_>`} className={st['separator']}>{'>'}</div>
                ]: ''
            })}
        </div>
    )
}
